import ApplicationLayout from '@rio-cloud/rio-uikit/ApplicationLayout';
import type { ReactNode } from 'react';

import AppHeader from './AppHeader';

export type PlainLayoutProps = {
    children: ReactNode;
};

/**
 * Shell for pages that render outside the authenticated application, such as the login and error
 * pages. It keeps the application header visible but omits navigation and user specific actions.
 */
const PlainLayout = ({ children }: PlainLayoutProps) => (
    <ApplicationLayout className='bg-lighter'>
        <ApplicationLayout.Header>
            <AppHeader />
        </ApplicationLayout.Header>
        <ApplicationLayout.Body>
            <div className='display-grid place-items-center height-100pct'>{children}</div>
        </ApplicationLayout.Body>
    </ApplicationLayout>
);

export default PlainLayout;
